import { MenuItemGroup } from '@/modules/application';
import { Permission } from '@/modules/users/submodules/roles/api/permissions.contracts';

export const LABEL_CONFIGURATION_SUB_MENU_ITEMS: MenuItemGroup[] = [
  {
    label: 'labels',
    children: [
      {
        activeRouteIds: ['/app/configuration/labels/*'],
        label: 'labels',
        url: '/app/configuration/labels/overview',
        requiredPermission: Permission.LABELS_VIEW,
      },
    ],
  },
];
